export const youtube_link = 'https://www.youtube.com/channel/UCN5Jr6dObLxEnT2CGAvnRiw';
export const linkedin_link = 'https://www.linkedin.com/company/vici-robotics';
export const facebook_link = 'https://www.facebook.com/vicirobotics/';
export const instagram_link = 'https://www.instagram.com/accounts/login/?next=/vicirobotics/%3Fhl%3Den';